// Som e vibração da leitura: dá para operar sem olhar para a tela.
let contexto: AudioContext | null = null;

function tom(freq: number, duracaoMs: number, atrasoMs = 0, volume = 0.25) {
  try {
    contexto ??= new AudioContext();
    const osc = contexto.createOscillator();
    const ganho = contexto.createGain();
    osc.type = "square";
    osc.frequency.value = freq;
    ganho.gain.value = volume;
    osc.connect(ganho).connect(contexto.destination);
    const inicio = contexto.currentTime + atrasoMs / 1000;
    osc.start(inicio);
    osc.stop(inicio + duracaoMs / 1000);
  } catch {
    // navegador sem áudio: segue só com vibração
  }
}

export function sinalOk() {
  tom(1320, 70);
  navigator.vibrate?.(40);
}

export function sinalConcluido() {
  tom(1046, 90);
  tom(1568, 140, 110);
  navigator.vibrate?.([40, 60, 40]);
}

export function sinalErro() {
  tom(196, 260);
  tom(196, 260, 320);
  navigator.vibrate?.([200, 100, 200]);
}
